import React, { useContext, useEffect, useState } from 'react'
import DynamicForm, { TField, useDynamicForm } from '../forms/DynamicFormNew'
import useService from '../../hooks/useService'
import { createOrUpdateAddress, getCityStateFromMts, getCustomerActiveAddresses } from '../../services/Customer'
import { CustomerContext } from '../../contexts/CustomerContext'
import { getPvcCenterAddresses } from '../../services/PVC'
import { AuthContext } from '../../contexts/AuthContext'
import { TInboundFields } from '../../Models/Inbound'
import { updateTransaction } from '../../services/Transactions'
import { TransactionContext } from '../../contexts/TransactionContext'
import { TPvcCenterAddress } from '../../Models/PVC'
import { ADDRESS_FORM_CONFIG, ICustomerAddress } from '../../Models/Customer'
import { NotificationContext } from '../../contexts/NotificationContext'
import { STATES, STATES_CODES_CLIENT, TRANSACTION_STATUS } from '../../utils/constant'
import Modal from '../Modals'
import { genId, getAddressesOptions } from '../../utils/helpers'
import EditIcon from '@mui/icons-material/Edit';
export let MTSStates: any = []

export type TTransactionAddresses = Pick<TInboundFields, 'billingAddressId' | 'shippingAddressId'>
const ADDRESS_CONFIG: TField<TTransactionAddresses>[] = [
  {
    fieldName: 'billingAddressId',
    isVisible: true,
    fieldType: 'select',
    label: 'Billing Address',
    fullWidth: false,
    options: []
  },
  {
    fieldName: 'shippingAddressId',
    isVisible: true,
    fieldType: 'select',
    label: 'Shipping Address',
    fullWidth: false,
    options: []
  },
]

const AddressCard = (props: { address: TPvcCenterAddress | ICustomerAddress, heading: string, showEdit: boolean }) => {
  const { address, heading, showEdit } = props
  const { name, line1, line2, city, country, state, id } = address
  const { pincode, phone } = address as TPvcCenterAddress
  const { mobileNumber, zip } = address as ICustomerAddress
  const postal = pincode ? pincode : zip
  const mobile = phone ? phone : mobileNumber
  const street = line2 ? line1 + ', ' + line2 : line1
  const fullAddress = `${street},
  ${city}, ${state} - ${postal} ${country}
  `

  const [showAddressForm, setShowAddressForm] = useState<boolean | string>(false)

  return (
    <div style={{ border: '1px solid silver', borderRadius: '10px', color: 'var(--text_color_2)' }}>
      <h3 style={{ color: 'var(--text_color)', background: '#f1f1f1', padding: '10px', borderRadius: '10px 10px 0 0' }}>{heading}</h3>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
        <div style={{ display: 'flex', gap: '15px' }}>
          <div>
            <h4>{name}
            </h4>
          </div>
          {/* <div>
            {showEdit && <EditIcon fontSize='small' onClick={() => setShowAddressForm(id as string)} />}
          </div> */}
        </div>
        <p>
          <span>
            {mobile}
          </span>
          <br />
          <span>
            {fullAddress}
          </span>
          <br />
        </p>
      </div>
      <CreateOrUpdateAddressForm
        open={Boolean(showAddressForm)}
        closeForm={() => setShowAddressForm(false)}
        id={typeof showAddressForm === 'string' ? showAddressForm : ''}
      />
    </div>
  )
}

const AddressTab = () => {

  const { execute } = useService()
  const { transactionInfo: { globalTransactionNumber, status: transactionStatus, transactionType }, inboundDetails: { billingAddressId, shippingAddressId }, setInboundDetails } = useContext(TransactionContext)
  // const { customerConfig: { customerRefNo }, customerAddresses } = useContext(CustomerContext)
  const { customerConfig, customerAddresses, customerConfig: { customerRefNo }, setCustomerConfig, setCustomerAddresses, mobileVerificationId } = useContext(CustomerContext)
  const { user: { centerId }, pvcAddresses } = useContext(AuthContext)
  const { notify } = useContext(NotificationContext)
  const [showAddressForm, setShowAddressForm] = useState<boolean | string>(false)

  const { registerForm, setFormConfig, setFormData, formData, setField } = useDynamicForm({
    formConfig: ADDRESS_CONFIG
  })
  const submitHandler = async (data: TTransactionAddresses) => {
    const { error } = await execute(() => updateTransaction({
      inbound: {
        globalTransactionNumber: globalTransactionNumber!,
        inboundHeader: { ...data } as TInboundFields,
      },
      transactionType
    }))

    if (error === null) {
      notify('Address updated.')
      setInboundDetails(prev => ({ ...prev, billingAddressId: data.billingAddressId, shippingAddressId: data.shippingAddressId }))
    }
  }

  useEffect(() => {
    if (customerRefNo) execute(() => getCustomerActiveAddresses({ customerRefNo }))
    if (centerId && customerConfig.isCorporate != 'Y') execute(() => getPvcCenterAddresses({ pvcCenterId: centerId }))
  }, [customerRefNo])

  useEffect(() => {
    if (pvcAddresses.length && customerConfig.isCorporate != 'Y') {
      setField('shippingAddressId', { options: pvcAddresses.map(address => ({ label: address.name + ' - ' + address.line1 + ' - ' + address.city, value: address.id })) })
    }
  }, [pvcAddresses])

  useEffect(() => {
    if (customerAddresses.length) {
      setField('billingAddressId', { options: getAddressesOptions(customerAddresses) })
      if (customerConfig.isCorporate === 'Y') setField('shippingAddressId', { options: getAddressesOptions(customerAddresses) })
    }
  }, [customerAddresses, customerRefNo])

  useEffect(() => {
    if (shippingAddressId) setFormData(prev => ({ ...prev, shippingAddressId }))
    if (billingAddressId) setFormData(prev => ({ ...prev, billingAddressId }))
  }, [])

  const handleAddAddress = () => {
    setShowAddressForm(true)
  }

  return (
    <div style={{ padding: '0 10px' }}>
      <div style={{ padding: '20px 0px' }}>
        <DynamicForm {...registerForm()} onSubmit={transactionStatus === TRANSACTION_STATUS.INBOUND_INITIATED ? submitHandler : undefined} submitText='Save' cancelText='Add Address' onCancel={handleAddAddress} />
      </div>
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ width: 'calc(50% - 10px)' }}>
          {formData.billingAddressId && customerAddresses.length ?
            <AddressCard showEdit={false} address={customerAddresses.filter(address => address.id === formData.billingAddressId)[0]} heading='Billing Address' /> :
            <></>}
        </div>
        <div style={{ width: 'calc(50% - 10px)' }}>
          {formData.shippingAddressId && customerConfig.isCorporate === 'Y' && customerAddresses.length ?
            <AddressCard
              showEdit={transactionStatus === TRANSACTION_STATUS.INBOUND_INITIATED}
              address={customerAddresses.filter(address => address.id === formData.shippingAddressId)[0]}
              heading='Shipping Address'
            /> :
            formData.shippingAddressId && pvcAddresses.length ?
              <AddressCard
                showEdit={transactionStatus === TRANSACTION_STATUS.INBOUND_INITIATED}
                address={pvcAddresses.filter(address => address.id === formData.shippingAddressId)[0]}
                heading='Shipping Address'
              /> :
              <></>}
        </div>
      </div>
      <CreateOrUpdateAddressForm
        open={Boolean(showAddressForm)}
        closeForm={() => setShowAddressForm(false)}
        id={typeof showAddressForm === 'string' ? showAddressForm : ''}
      />
    </div>
  )
}


export function CreateOrUpdateAddressForm({ closeForm, id, open }: { id?: string, open: boolean; closeForm: Function; }) {
  const { execute, store } = useService()
  const { notify } = store.notificationStore
  const { transactionInfo } = store.transactionsStore
  const { customerConfig: { customerRefNo }, customerAddresses, setCustomerAddresses, } = store.customerStore



  const { registerForm, setFormData, setField, formData,setFormConfig } = useDynamicForm({
    formConfig: ADDRESS_FORM_CONFIG
  })
  useEffect(() => {
   
    setFormConfig(prev => {
        return [...prev.map(field => {
            if ( field.fieldName === 'country') {
                field.disabled = true
            }
            return field
        })]
    })


}, [])

  const submitHandler = async (data: ICustomerAddress) => {
    data.zip = Number(data.zip)
    data.country = "India"
    let stateCode = ""

    STATES_CODES_CLIENT.forEach((state) => {
      if (state.value === data.state)
        stateCode = state.code
    })
    let stateCodeFromMaster: any = await getStateCodeFromMaster(data.state)
    data.stateCode = stateCodeFromMaster
    data.customerRefNo = customerRefNo
    if (Boolean(id)) updateHandler(data)

    else createAddress(data)

    notify('Address Updated.')
    handleClose()
  }


  async function getStateCodeFromMaster(stateorcity: any) {
    let stateCode = true;
    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode }))
    //@ts-ignore
    if (data != null) return data[0]?.state_code
  }

  const handleClose = () => {
    closeForm()
  };

  const createAddress = async (address: any) => {
    const { error, data } = await execute(() => createOrUpdateAddress(address))
    if (error === null) {
      notify('Address updated.')
      // setCustomerAddresses(prev => ([...prev, { ...address, id: genId() }])) 
      return setCustomerAddresses(prev => ([...prev, { ...(data ? data : address) }]));
    }
  }

  const updateHandler = async (data: any) => {
    const { error } = await execute(() => createOrUpdateAddress(data))
    if (error === null) {
      setCustomerAddresses(prev => {
        return prev.map(address => address.id === id ? { ...data, id } : address)
      })
      notify('Address updated.')
    }
  }

  useEffect(() => {
    if (open && id) setFormData(customerAddresses.filter(address => address.id === id)[0])
    // else if (addressType === 'D') {
    //   setFormData(customerAddresses.filter(address => address.type === 'B')[0]) }
    else setFormData({} as ICustomerAddress)
    let country = "CNIND"
    getstatecity(country)
  }, [open])

  useEffect(() => {
    let country = "CNIND"
    getstatecity(country)
  }, [customerAddresses, customerRefNo,])


  useEffect(() => {
    // let  MTScity : any = []
    // setField('city', {options:MTScity })
    if (formData.state) getCityFromMaster(formData.state)
  }, [formData.state])


  useEffect(() => {
    let country = "CNIND"
    getstatecity(country)
  }, [])





  async function getCityFromMaster(stateorcity: any) {
    let stateCode = false

    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode }))
    if (data!) {
      // MTScity =[]
      let updated_cities = [];
      //@ts-ignore
      for (let i = 0; i < data.length; i++) {
        //@ts-ignore
        let cities = { value: data[i].domain_description, label: data[i].domain_description, code: i + 1 }
        updated_cities.push(cities)
      }
      setField('city', { options: updated_cities })

    }

  }




  async function getstatecity(stateorcity: any) {
    let stateCode = false
    const { data, error } = await execute(() => getCityStateFromMts({ stateorcity, stateCode }))
    let MTSStates = []
    if (data! && MTSStates.length === 0) {
      //@ts-ignore
      for (let i = 0; i < data.length; i++) {
        //@ts-ignore
        let state = { value: data[i].domain_description, label: data[i].domain_description, code: "25" }
        MTSStates.push(state)
        setField('state', { options: MTSStates })
      }
    }
  }









  return (
    <Modal open={open} title={Boolean(id) ? 'Edit Address' : 'Add Address'} onClose={closeForm}>
      <DynamicForm
        onSubmit={transactionInfo.status === TRANSACTION_STATUS.INBOUND_INITIATED ? submitHandler : undefined}
        submitText='Save'
        cancelText='Cancel'
        onCancel={handleClose}
        {...registerForm()}
      />
    </Modal>
  );
}

export default AddressTab
